import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { listMutations } from './types';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		Pujcovna: [],
		DphSazba: [],
		VpaVaria: [],
	},
	filter: {
		PujcovnaId: null as number | null,
		PujcovnapaNr: null as number | null,
		ZakaznikId: null as number | null,
		ZakaznikIdText: null as string | null,
		VozidlopaId: null as number | null,
		VozidlopaIdText: null as string | null,
		VozidlopaSpz: null as string | null,
		VozidlopaKaroserieNr: null as number | null,
		ZakazkaId: null as number | null,
		ZakazkaIdText: null as string | null,
		ZakazkaIdNr: null as number | null,
		DokladPfx: null as string | null,
		DokladNr: null as number | null,
		Text: null as string | null,
		PujckaDatOdMin: null as string | null,
		PujckaDatOdMax: null as string | null,
		PujckaDatDoMin: null as string | null,
		PujckaDatDoMax: null as string | null,
		PcOd: null as number | null,
		PcDo: null as number | null,
		DphSzbOzn: null as number | null,
		VyrazenPrp: null as boolean | null,
		VlastnivozPrp: null as boolean | null,
		ExternivozPrp: null as boolean | null,
		NajemnivozPrp: null as boolean | null,
		VpripravePrp: null as boolean | null,
		PujcenePrp: null as boolean | null,
		VracenoPrp: null as boolean | null,
		KfakturaciPrp: null as boolean | null,
		FakturovanePrp: null as boolean | null,
		DloudobaZapujckaPrp: null as boolean | null,
		VstupPracId: null as number | null,
		VstupPracIdText: null as string | null,
		VstupPracOsobniCis: null as string | null,
		VstupDatDo: null as string | null,
		VstupDatOd: null as string | null,
		VozidlopaVaria: null as number[] | null,
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[listMutations.ZAPUJCKA_VOZIDLO_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.VozidlopaId = data.id;
			state.filter.VozidlopaSpz = data.rzv;
			state.filter.VozidlopaKaroserieNr = data.vin;
		},
		[listMutations.ZAPUJCKA_ZAKAZKA_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.ZakazkaId = data.value;
			state.filter.ZakazkaIdText = data.text;
			state.filter.ZakazkaIdNr = data.nr;
		},
		[listMutations.ZAPUJCKA_VSTUP_PRAC_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.VstupPracId = data.value;
			state.filter.VstupPracIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.filter.VstupPracOsobniCis = data.osobniCis;
		},
		[listMutations.ZAPUJCKA_ZAKAZNIK_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.ZakaznikId = data.value;
			state.filter.ZakaznikIdText = data.text;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
		isFilterVisible: true,
	},
});
